import { useEffect, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GalleryPage() {
  const { t, lang } = useLanguage();
  const [images, setImages] = useState([]);
  const [selectedImg, setSelectedImg] = useState(null);

  useEffect(() => {
    axios.get(`${API}/gallery`).then(r => setImages(r.data)).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = images;

  return (
    <div className="pt-20 lg:pt-24 pb-20" data-testid="gallery-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-heading text-4xl sm:text-5xl font-bold text-[#1a1a1a] tracking-tight"
          >
            {t('gallery.title')}
          </motion.h1>
          <p className="text-[#555555] mt-3">{t('gallery.subtitle')}</p>
          <div className="w-16 h-1 mx-auto mt-4" style={{ backgroundColor: '#f4d00d' }} />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="gallery-grid">
          {filtered.map((img, i) => (
            <motion.div
              key={img.id}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <Dialog>
                <DialogTrigger asChild>
                  <button className="w-full card-hover rounded-xl overflow-hidden border border-[#e0e0e0] group" data-testid={`gallery-image-${i}`}>
                    <div className="aspect-square overflow-hidden">
                      <img
                        src={img.url}
                        alt={lang === 'fr' ? img.caption_fr : img.caption_en}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    {(img.caption_fr || img.caption_en) && (
                      <div className="p-3 bg-white">
                        <p className="text-sm text-[#1a1a1a] font-medium">{lang === 'fr' ? img.caption_fr : img.caption_en}</p>
                      </div>
                    )}
                  </button>
                </DialogTrigger>
                <DialogContent className="max-w-3xl p-0 overflow-hidden">
                  <img
                    src={img.url}
                    alt={lang === 'fr' ? img.caption_fr : img.caption_en}
                    className="w-full max-h-[80vh] object-contain"
                  />
                  {(img.caption_fr || img.caption_en) && (
                    <div className="p-4 text-center">
                      <p className="font-medium">{lang === 'fr' ? img.caption_fr : img.caption_en}</p>
                    </div>
                  )}
                </DialogContent>
              </Dialog>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
